module.exports = __webpack_public_path__ + "static/hamburg-2019-516dc2394d6d7b0ce459a903ab906bd4.jpg";